import React, { FC, useCallback, useState } from 'react';
import { faPen, faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import confirm from 'src/common/confirm';
import modalStyles from 'src/common/Modal/index.module.scss';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { FieldViewMode } from 'src/shared/Tender/Boxes/types';
import EditView from './EditView';
import classNames from 'classnames';
import { ICustomBidField } from 'src/models/company/CustomBidFields/types';
import { useDeleteCustomBidField } from 'src/models/company/CustomBidFields/hooks';
import ReadOnlyBlock from 'src/shared/Blocks/Text/ReadOnlyBlock';

interface IProps {
  item: ICustomBidField;
  readOnly: boolean;
}

export const CategoryItem: FC<IProps> = props => {
  const { item, readOnly } = props;
  const { t } = useTranslation();

  const [onDelete, { loading }] = useDeleteCustomBidField();

  const onRemove = useCallback(() => {
    confirm.confirm({
      title: t('CustomBidFields.deleteBidField'),
      content: t('CustomBidFields.deleteBidFieldConfirm'),
      okText: t('Common.delete'),
      cancelText: t('Common.cancel'),
      className: modalStyles.confirmModal,
      centered: true,
      okButtonProps: {
        loading
      },
      onOk() {
        onDelete(item.id);
      }
    });
  }, [item.id, loading, onDelete, t]);

  const [mode, setMode] = useState(FieldViewMode.Read);

  const onToggleMode = useCallback(() => {
    setMode(prev => (prev === FieldViewMode.Read ? FieldViewMode.Edit : FieldViewMode.Read));
  }, []);

  const onReadMode = useCallback(() => {
    setMode(FieldViewMode.Read);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {mode === FieldViewMode.Read && (
          <>
            <ReadOnlyBlock string={item.name} />
          </>
        )}
        {mode === FieldViewMode.Edit && <EditView name={item.name} id={item.id} onClose={onReadMode} />}
      </div>
      {!readOnly && (
        <div className={styles.actions}>
          <button
            onClick={onToggleMode}
            className={classNames(styles.button, { [styles.isActive]: mode === FieldViewMode.Edit })}
          >
            <FontAwesomeIcon icon={faPen} />
          </button>
          <button onClick={onRemove} className={styles.button}>
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </div>
      )}
    </div>
  );
};

export default CategoryItem;
